import styled from 'styled-components';

import { BasicTitle, BigSubtitle, style } from '@genially/design-system';

// Matches the approved design's width, wider than the other HostGame sidebars.
const SIDEBAR_WIDTH_UNITS = 42.625;

interface WrapperProps {
  $isOpen: boolean;
}

export const Wrapper = styled.div<WrapperProps>(
  ({ theme: { color, size, transition }, $isOpen }) => ({
    height: '100%',
    width: $isOpen ? size.units(SIDEBAR_WIDTH_UNITS) : 0,
    flexShrink: 0,
    overflow: 'hidden',
    backgroundColor: color.background.reversed.default(),
    transition: transition.standard('width'),

    // On mobile it overlays the genially fullscreen instead of pushing it aside.
    // zIndex 20 matches HostPreLobby's, sitting above HostGame's header/sidebars (2-3)
    // and ReactionsOverlay (10).
    ...style.mixins.responsive.sm.downward({
      position: 'fixed',
      top: 0,
      left: 0,
      zIndex: 20,
      width: $isOpen ? '100%' : 0,
    }),
  }),
);

export const InnerWrapper = styled.div(({ theme: { size } }) => ({
  width: size.units(SIDEBAR_WIDTH_UNITS),
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  padding: size.units(2),

  ...style.mixins.responsive.sm.downward({
    width: '100%',
  }),
}));

export const Content = styled.div(({ theme: { size } }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: size.units(3),
}));

export const QRCodeWrapper = styled.div({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
});

export const Subtitle = styled(BigSubtitle)(({ theme: { color } }) => ({
  color: color.content.reversed.default(),
  textAlign: 'center',
}));

export const SessionCode = styled(BasicTitle)(({ theme: { color } }) => ({
  color: color.content.reversed.default(),
  textAlign: 'center',
}));
